import React, { useState } from 'react';
import { store } from 'react-notifications-component';
import InputV3 from '../input/novo/input_v3';
import InputV2 from "../../components/input/input_v2";
import { BodyM, TaglineM } from '../../styles/stylesTypography';
import { theme } from '../../styles/theme';
import * as S from './styles';
import api from '../../services/api';
import identifyErrorMenssage from '../../services/identifyErrorMenssage';
import validadorCpfCnpj from '../../services/validadorCpfCnpj';
import validadorDeEmail from '../../services/validadorEmail';

import { Loading } from '../loading';

const formatCPFOrCNPJ = (value) => {
  const cleaned = value.replace(/\D/g, '');
  return cleaned.length <= 11 ? formatCPF(value) : formatCNPJ(value);
};

const formatCPF = (value) => {
  if (!value) return "";
  value = value.replace(/\D/g, "");
  value = value.replace(/(\d{3})(\d)/, "$1.$2");
  value = value.replace(/(\d{3})(\d)/, "$1.$2");
  value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  return value;
};

const formatCNPJ = (value) => {
  if (!value) return "";
  value = value.replace(/\D/g, "");
  value = value.replace(/(\d{2})(\d)/, "$1.$2");
  value = value.replace(/(\d{3})(\d)/, "$1.$2");
  value = value.replace(/(\d{3})(\d)/, "$1/$2");
  value = value.replace(/(\d{4})(\d{1,2})$/, "$1-$2");
  return value;
};

const formatPhone = (value) => {
  const cleaned = value.replace(/\D/g, '');
  if (cleaned.length <= 10) {
    return cleaned.replace(/(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3');
  }
  return cleaned.replace(/(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3');
};

const formatCEP = (value) => {
  return value.replace(/\D/g, '').replace(/(\d{5})(\d{0,3})/, '$1-$2').slice(0, 9);
};

const stateOptions = [
  "AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", "MA",
  "MT", "MS", "MG", "PA", "PB", "PR", "PE", "PI", "RJ", "RN",
  "RS", "RO", "RR", "SC", "SP", "SE", "TO"
].map(uf => ({ value: uf, label: uf }));

export default function RegisterProducer({ onSuccess, onCancel }) {
  const [form, setForm] = useState({
    name: '', email: '', cpfCnpj: '', telefone: '', celular: '',
    cep: '', logradouro: '', bairro: '', numero: '', complemento: '',
    cidade: '', estado: ''
  });


  const [errors, setErrors] = useState({});
  const [cpfCnpjErrorMsg, setCpfCnpjErrorMsg] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const validate = async () => {
    const err = {
      name: !form.name.trim(),
      email: form.email && !validadorDeEmail(form.email),
      cpfCnpj: form.cpfCnpj.replace(/\D/g, '').length < 11,
      telefone: form.telefone.replace(/\D/g, '').length < 10,
      cep: form.cep.replace(/\D/g, '').length !== 8,
      logradouro: !form.logradouro.trim(),
      bairro: !form.bairro.trim(),
      numero: !form.numero.trim(),
      cidade: !form.cidade.trim(),
      estado: !form.estado
    };

    if (!err.cpfCnpj) {
      const resultado = await validadorCpfCnpj(form.cpfCnpj);
      if (!resultado.valido) {
        err.cpfCnpj = true;
        setCpfCnpjErrorMsg(resultado.erro || 'Informe um CPF/CNPJ válido.');
      } else {
        setCpfCnpjErrorMsg('');
      }
    } else {
      setCpfCnpjErrorMsg('Campo obrigatório');
    }

    setErrors(err);
    return !Object.values(err).includes(true);
  };

  const handleChange = (field, value) => {
    setForm({ ...form, [field]: value });
    if (errors[field]) setErrors({ ...errors, [field]: false });
  };

  const handleBlurCpfCnpj = async () => {
    if (!form.cpfCnpj.replace(/\D/g, '').trim()) return;

    const resultado = await validadorCpfCnpj(form.cpfCnpj);
    if (!resultado.valido) {
      setErrors(prev => ({ ...prev, cpfCnpj: true }));
      setCpfCnpjErrorMsg(resultado.erro || 'Informe um CPF/CNPJ válido.');
    } else {
      setErrors(prev => ({ ...prev, cpfCnpj: false }));
      setCpfCnpjErrorMsg('');
    }
  };

  const handleCepLookup = async (cep) => {
    const cleanedCep = cep.replace(/\D/g, '');
    if (cleanedCep.length === 8) {
      try {
        const res = await fetch(`https://viacep.com.br/ws/${cleanedCep}/json/`);
        const data = await res.json();

        if (!data.erro) {
          setForm(prev => ({
            ...prev,
            logradouro: data.logradouro || "",
            bairro: data.bairro || "",
            cidade: data.localidade || "",
            estado: data.uf || ""
          }));
        }
      } catch (e) {
        console.error('Erro ao buscar CEP:', e);
      }
    }
  };

  const handleSave = async () => {
    if (!(await validate())) {
      store.addNotification({
        title: "Erro!",
        message: "Preencha todos os campos obrigatórios",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true }
      });
      return;
    }

    setIsLoading(true);
    try {
      await api.post("/produtores", {
        nome: form.name,
        email: form.email,
        cpf_cnpj: form.cpfCnpj,
        telefone: form.telefone,
        celular: form.celular,
        cep: form.cep,
        logradouro: form.logradouro,
        bairro: form.bairro,
        numero: form.numero,
        complemento: form.complemento,
        cidade: form.cidade,
        estado: form.estado.value || form.estado,
        // Envia a receita por e-mail sempre que o produtor tiver um e-mail válido cadastrado.
        enviar_receita: validadorDeEmail(form.email) ? 1 : 0
      });

      store.addNotification({
        title: "Sucesso!",
        message: `Produtor adicionado com sucesso`,
        type: "success",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true }
      });
      onSuccess();
    } catch (err) {
      store.addNotification({
        title: "Erro!",
        message: identifyErrorMenssage(err, "ERRO-554 Erro ao salvar - Tente novamente, se o erro persistir acione o suporte."),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true }
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <S.ContainerModalAddProducer>
      <BodyM fontWeight={800}>Cadastre um novo Produtor</BodyM>

      <div style={{ width: "100%", maxWidth: "440px", height: "auto", gap: "16px", display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
        <InputV3 floatingLabelWithAsterisk="Nome do produtor" value={form.name} onChange={e => handleChange('name', e.target.value)} hasError={errors.name} />
        
        {/* <InputV3 id="email" type="email" autoComplete="email" floatingLabel="E-mail" value={form.email} onChange={e => handleChange('email', e.target.value)} hasError={errors.email} /> */}

        <S.ContainerInput>
         <InputV2
            id="email"
            label="E-mail"
            type="email"
            name="email"
            value={form.email}
            onChange={(value) => {handleChange('email', value)}}
            onBlur={() => setErrors({ ...errors, email: form.email && !validadorDeEmail(form.email) })}
            erro={errors.email}
            messageErro={errors.email ? 'Insira um e-mail válido.' : ''}
            height="auto"
            inputColor="#8A92A2"
            marginLeft="13px"
            color="#8A92A2"
            fontSize="13px"
            padding="13px 15px 12px 16px"
            inputFontSize="14px"
            inputFontWeight="regular"
          />
        </S.ContainerInput>
          
        <InputV3 floatingLabelWithAsterisk="CPF/CNPJ" value={formatCPFOrCNPJ(form.cpfCnpj)} onChange={e => handleChange('cpfCnpj', e.target.value)} onBlur={handleBlurCpfCnpj} maxLength={18} hasError={errors.cpfCnpj} errorInfo={cpfCnpjErrorMsg} />
        <InputV3 floatingLabelWithAsterisk="Telefone" value={formatPhone(form.telefone)} onChange={e => handleChange('telefone', e.target.value)} maxLength={15} hasError={errors.telefone} />
        <InputV3 floatingLabel="Celular" value={formatPhone(form.celular)} onChange={e => handleChange('celular', e.target.value)} maxLength={15} />
        <InputV3 floatingLabelWithAsterisk="CEP" value={formatCEP(form.cep)} onBlur={() => handleCepLookup(form.cep)} onChange={e => handleChange('cep', e.target.value)} maxLength={9} hasError={errors.cep} />
        <InputV3 floatingLabelWithAsterisk="Logradouro" value={form.logradouro} onChange={e => handleChange('logradouro', e.target.value)} hasError={errors.logradouro} />
        <InputV3 floatingLabelWithAsterisk="Bairro" value={form.bairro} onChange={e => handleChange('bairro', e.target.value)} hasError={errors.bairro} />
        <InputV3 floatingLabelWithAsterisk="Número" value={form.numero} onChange={e => handleChange('numero', e.target.value)} hasError={errors.numero} />
        <InputV3 floatingLabel="Complemento" value={form.complemento} onChange={e => handleChange('complemento', e.target.value)} />
        <InputV3 floatingLabelWithAsterisk="Cidade" value={form.cidade} onChange={e => handleChange('cidade', e.target.value)} hasError={errors.cidade} />
        <InputV3
          type="select"
          floatingLabelWithAsterisk="Estado"
          value={stateOptions.find(o => o.value === form.estado) || null}
          onChange={option => handleChange('estado', option)}
          options={stateOptions}
          hasError={errors.estado}
          floatingValue={form.estado ? form.estado.value || form.estado : ""}
        />
      </div>

      <S.ContainerButtonsModal>
        <S.ButtonCancelModal onClick={onCancel}>
          <TaglineM fontWeight={theme.typography.fontWeight.extraBold} color={theme.colors.green.Verde_AgroReceita}>Cancelar</TaglineM>
        </S.ButtonCancelModal>
        
        <S.ButtonSavedModal onClick={handleSave}>
          <TaglineM fontWeight={theme.typography.fontWeight.extraBold} color={theme.colors.white.Branco}>
            {isLoading ? <Loading size="20px" color={theme.colors.white.Branco}/> : "Salvar"}
          </TaglineM>
        </S.ButtonSavedModal>
      </S.ContainerButtonsModal>
    </S.ContainerModalAddProducer>
  );
}
